import { render, staticRenderFns } from "./specific.vue?vue&type=template&id=1a3c92b7"
import script from "./specific.vue?vue&type=script&lang=js"
export * from "./specific.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports